import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import { IPayload } from 'models/Global'
import { IScreeningDocument } from 'models/ScreeningDocument'

export class ScreeningDocumentsApi {
  constructor(private axios: AxiosService) {}

  postScreeningDocument = async (params: FormData) => {
    const response = await this.axios.post<IPayload<IScreeningDocument>>(
      Endpoints.postScreeningDocument,
      params,
    )
    return response
  }
}
